(function () {
  'use strict';

  /* @ngdoc object
   * @name main.llicencies
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.sessions', [
      'ui.router'
    ]);
}());
